import React, { useState, useMemo, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdfFile from "../../src/MK_Metal_Mobile.pdf";
import {
  mobileCurrentPage,
  pdfPage,
  pdfRef,
  scaleValue,
  thumnail,
} from "../atoms";
import { useRecoilState, useRecoilValue } from "recoil";
import { useControls } from "react-zoom-pan-pinch";
import { useMediaQuery } from "@mui/material";
import styled from "styled-components";
import useMobilePageNavigation from "./useMobilePageNavigation";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

const DocumentStyled = styled(Document)``;
const PageStyled = styled(Page)`
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 1px 5px 10px rgba(0, 0, 0, 0.2);
`;

const LeftBox = styled.div`
  width: 30px;
  height: 100%;
  cursor: pointer;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  visibility: ${(props) => (props.$currentPage === 1 ? "hidden" : "visible")};
`;
const RightBox = styled.div`
  width: 30px;
  height: 100%;
  cursor: pointer;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.1) 100%
  );
  visibility: ${(props) =>
    props.$currentPage === props.$numPage ? "hidden" : "visible"};
`;

function MobileFlipbook() {
  const {
    currentPage,
    numPages,
    inputValue,
    moveToPage,
    setInputValue,
    setCurrenPage,
    setNumPages,
  } = useMobilePageNavigation();

  const { setTransform, centerView } = useControls();
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const [openThumnail, setOpenThumnail] = useRecoilState(thumnail);

  useEffect(() => {
    const centerWidth = (window.innerWidth - 595 * 0.6) / 2;
    const centerHeight =
      (window.innerHeight - 841 * 0.6 - (openThumnail ? 135 : 0)) / 2;
    setTimeout(() => {
      setTransform(centerWidth, centerHeight, 0.6, 100, "easeOut");
    }, 100);
  }, [window.innerWidth, openThumnail]);
  return (
    <DocumentStyled file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
      <PageStyled
        pageNumber={currentPage}
        renderTextLayer={false}
        renderAnnotationLayer={false}
      />
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <LeftBox
          $currentPage={currentPage}
          onClick={() => moveToPage("prev")}
        />
        <RightBox
          $currentPage={currentPage}
          $numPage={numPages}
          onClick={() => moveToPage("next")}
        />
      </div>
    </DocumentStyled>
  );
}

export default MobileFlipbook;
